import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress
} from '@mui/material';
import useFetchData from '../Hooks/useFetchData';
import './F2FCallsOverview.css';

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export default function F2FCallsOverview({ title, endpoint, fromDate, toDate }) {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { stats, loading, fetchData } = useFetchData(apiUrl, endpoint);
  const [rows, setRows] = useState([]);

  // 1) Fetch on mount or date‑filter change
  useEffect(() => {
    const params = {};
    if (fromDate) params.from_date = fromDate;
    if (toDate)   params.to_date   = toDate;
    fetchData(params);
  }, [endpoint, fromDate, toDate]);

  // 2) Pivot on avg_calls_per_working_day
  useEffect(() => {
    if (!stats.data) return;
    const map = {};
    stats.data.forEach(({ territory, employee_name, month, avg_calls_per_working_day }) => {
      if (!map[employee_name]) {
        map[employee_name] = {
          territory,
          employee_name,
          values: {}
        };
      }
      // key each month to the *average* instead of the raw calls
      map[employee_name].values[month] = avg_calls_per_working_day;
    });

    // Build an array for rendering
    const list = Object.values(map);
    setRows(list);
  }, [stats.data]);

  return (
    <Box className="f2f-container">
      <Typography className="f2f-title">{title}</Typography>
      {loading ? (
        <Box className="f2f-loader">
          <CircularProgress />
        </Box>
      ) : (
        <Table className="f2f-table" size="small">
          <TableHead>
            <TableRow>
              <TableCell>Territory</TableCell>
              <TableCell>Rep</TableCell>
              {MONTHS.map(m => (
                <TableCell key={m} align="right">{m}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, idx) => (
              <TableRow key={idx}>
                <TableCell>{r.territory}</TableCell>
                <TableCell>{r.employee_name}</TableCell>
                {MONTHS.map(m => (
                  <TableCell key={m} align="right">
                    {r.values[m] != null
                      ? r.values[m].toFixed(2)
                      : '—'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Box>
  );
}